document.addEventListener('DOMContentLoaded', () => {
  //console.log('DOM is ready');

  const check_contact_us = document.querySelectorAll('a[href="/pages/contact"]');
  check_contact_us.forEach(btn => {
     btn.addEventListener('click', (event) => {
      event.preventDefault();
      //console.log("anchor found", btn);
        openModal();
     });
  });
  const openBtns = document.querySelectorAll('[data-enabled-customer-form]');

  const modal = document.getElementById('customerCareModal');

  if (!modal || !openBtns.length) return;

  const closeBtn = modal.querySelector('.close');
  let previousScrollY = 0;

  function openModal() {
    const scrollY = window.scrollY;
    previousScrollY = scrollY;

     // Prevent layout thrashing by separating DOM reads from DOM writes
      requestAnimationFrame(() => {
      document.body.dataset.scrollY = scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';

      modal.classList.add('show');
      modal.setAttribute('open', true);
      });
  }

  function closeModal () {
    modal.classList.remove('show');
    modal.removeAttribute('open');

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';

    delete document.body.dataset.scrollY;
    window.scrollTo({ top: previousScrollY, behavior: 'instant' });
  }

  openBtns.forEach(btn => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();

      // Optional value check
      if (btn.dataset.enabledCustomerForm === 'true' || btn.hasAttribute('data-enabled-customer-form')) {
        openModal();
      }
    });
  });
  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }
  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      closeModal();
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('show')) {
      closeModal();
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const mediaQuery = window.matchMedia("(max-width: 768px)");
  let swiperInstance = null;

  
  function toggleSwiper() {
    const slider = document.querySelector('[id^="enable-slider-on-mobile"]');
    if (!slider) return;

    const wrapper = slider.querySelector(".multicolumn-grid-column");
    const slides = slider.querySelectorAll(".multicolumn-card-column");
    const pagination = slider.querySelector(".swiper-paginate-custom");

    if (mediaQuery.matches) {
      slider.classList.add("swiper");
      wrapper.classList.add("swiper-wrapper");
      pagination.classList.add("swiper-pagination");
      slides.forEach(slide => slide.classList.add("swiper-slide"));

      if (!swiperInstance) {
        swiperInstance = new Swiper(slider, {
          slidesPerView: 1.2,
          spaceBetween: 5,
          loop: true,
          pagination: {
            el: pagination,
            clickable: true
          }
        });
      }
    } else {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }

      slider.classList.remove("swiper");
      wrapper.classList.remove("swiper-wrapper");
      pagination.innerHTML = "";
      pagination.classList.remove("swiper-pagination");
      slides.forEach(slide => slide.classList.remove("swiper-slide"));
    }
  }

  toggleSwiper();
  mediaQuery.addEventListener("change", toggleSwiper);
 
function multicolumn_slider_mobile() {
  const sliders = document.querySelectorAll('[data-enable_slider_on_mobile]');
  if (!sliders.length) return;

  sliders.forEach(slider => {

    const wrapper = slider.querySelector(".section-content-wrapper");
    const slides = slider.querySelectorAll(".group-block");
    const pagination = slider.querySelector(".swiper-paginate-mulitcolumn");

    // Store swiper instance on the element itself
    let swiperInstance = slider.swiperInstance;

    if (mediaQuery.matches) {

      slider.classList.add("swiper");
      wrapper.classList.add("swiper-wrapper");
      pagination.classList.add("swiper-pagination");
      slides.forEach(slide => slide.classList.add("swiper-slide"));

      if (!swiperInstance) {
        swiperInstance = new Swiper(slider, {
          slidesPerView: 1.2,
          spaceBetween: 5,
          loop: true,
          pagination: {
            el: pagination,
            clickable: true
          }
        });

        slider.swiperInstance = swiperInstance; // save instance check
      }

    } else {

      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        slider.swiperInstance = null;
      }

      slider.classList.remove("swiper");
      wrapper.classList.remove("swiper-wrapper");
      pagination.innerHTML = "";
      pagination.classList.remove("swiper-pagination");
      slides.forEach(slide => slide.classList.remove("swiper-slide"));
    }
  });
}

multicolumn_slider_mobile();
mediaQuery.addEventListener("change", multicolumn_slider_mobile);

const DESKTOP_WIDTH = 1024;
function multicolumn_slider_desktop() {
  const sliders = document.querySelector('[data-enable-carousel-desktop]');
  //console.log("s", sliders);
   if (!sliders) return;
   //console.log("s22", sliders);
  document.querySelectorAll('[data-enable-carousel-desktop]').forEach(slider => {
    const swiperEl = slider.querySelector('.swiper-on-desktop');
    const wrapper = slider.querySelector('.section-content-wrapper');
    const slides = slider.querySelectorAll('.group-block');
    slider.classList.add('swiper', 'swiper-initialized');
    let swiper = slider.swiper || null;

    // 🖥️ DESKTOP → ENABLE SWIPER
    if (window.innerWidth >= DESKTOP_WIDTH) {
      if (!swiper) {
        new Swiper(slider, {
          slidesPerView: 3,
          spaceBetween: 5,
          loop: true,
          pagination: {
            el: slider.querySelector('.swiper-pagination'),
            clickable: true
          },
          navigation: {
            nextEl: slider.querySelector('.swiper-next-multicolumn'),
            prevEl: slider.querySelector('.swiper-prev-multicolumn'),
          }
        });
      }
      return;
    }

    // 📱 MOBILE → DISABLE SWIPER COMPLETELY
    if (swiper) {
      swiper.destroy(true, true);
      slider.classList.remove('swiper', 'swiper-initialized');
    }

    // 🔧 Restore normal layout
   // console.log("s22ssss", sliders);
    slider.style.overflow = 'visible';
    wrapper.style.transform = 'none';
    wrapper.style.display = 'flex';
    wrapper.style.flexWrap = 'wrap';

    slides.forEach(slide => {
      slide.style.width = '100%';
      slide.style.marginRight = '0';
    });
  });
}

multicolumn_slider_desktop();
window.addEventListener('resize', multicolumn_slider_desktop);


function image_carousel_custom() {
    const sliders = document.querySelectorAll('[data-enable-carousel]');
    if (!sliders) return;
    //console.log("sliders", sliders);
    sliders.forEach(slider => {
      const per_column_show = slider.dataset.perColumn;
      const paginate = slider.querySelector('.custom-paginate-image-section-ctm');
      const navigation_next = slider.querySelector('.custom-img-next-pgi');
      const navigation_perv = slider.querySelector('.custom-img-prev-prev');
      //console.log("this", slider);
      //console.log("paginate", paginate);
      //console.log("per_column_show", per_column_show);
       var swiper = new Swiper(slider, {
        slidesPerView: per_column_show,
        spaceBetween: 10,
        pagination: {
          el: paginate,
          clickable: true,
        },
        hashNavigation: {
          watchState: true,
        },
         navigation: {
          nextEl: navigation_next,
          prevEl: navigation_perv,
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: per_column_show,
            spaceBetween: 50,
          },
        },
      });
    });
}

image_carousel_custom();
// mediaQuery.addEventListener("change", multicolumn_slider_desktop);   
  
    // function multicolumn_slider_desktop() {
    //     const sliders = document.querySelectorAll('[data-enable-carousel-desktop]');

    //     sliders.forEach(slider => {
    //       const swiperEl = slider.querySelector('.swiper-on-desktop');
    //       console.log("swiperEl", swiperEl, "swiper", slider);
    //       const wrapper = slider.querySelector('.section-content-wrapper');
    //       const slides = slider.querySelectorAll('.group-block');
    //       const navigation = slider.querySelector('.navigation-desktop-slider');

    //       const isDesktop = !mediaQuery.matches; // adjust if your mediaQuery differs
    //       let swiperInstance = slider.swiper || null;

    //       // 🖥️ DESKTOP → INIT
    //       if (isDesktop) {
    //         if (!swiperInstance) {
    //           new Swiper(slider, {
    //             slidesPerView: 3,
    //             spaceBetween: 5,
    //             loop: true,
    //             pagination: {
    //               el: slider.querySelector('.swiper-pagination'),
    //               clickable: true
    //             },
    //             navigation: {
    //               nextEl: slider.querySelector('.swiper-next-multicolumn'),
    //               prevEl: slider.querySelector('.swiper-prev-multicolumn'),
    //             }
    //           });
    //         }
    //         return;
    //       }

    //       // 📱 MOBILE → DESTROY & CLEANUP
    //       if (swiperInstance) {
    //         swiperInstance.destroy(true, true);
    //       }else{
    //         swiperInstance.init();
    //           slider.classList.add('swiper', 'swiper-initialized');
    //           wrapper.classList.add('swiper-wrapper');

    //           slides.forEach(slide => {
    //             slide.classList.add(
    //               'swiper-slide',
    //               'swiper-slide-active',
    //               'swiper-slide-next'
    //             );
    //             //slide.setAttribute('style');
    //           });
    //       }

    //       slider.classList.remove('swiper', 'swiper-initialized');
    //       wrapper.classList.remove('swiper-wrapper');
    //       navigation.innerHTML = '';

    //       slides.forEach(slide => {
    //         slide.classList.remove(
    //           'swiper-slide',
    //           'swiper-slide-active',
    //           'swiper-slide-next'
    //         );
    //         slide.removeAttribute('style');
    //       });
    //     });
    // }


});
